// MobileConstants.js
// Enterprise-grade configuration constants
// Single source of truth for all mobile-related values

export const MOBILE_CONSTANTS = {
    // Breakpoints (based on industry standards) - AUTHORITATIVE VALUES
    BREAKPOINTS: {
        MOBILE_SMALL: 480,   // iPhone SE, small phones
        MOBILE: 768,         // Standard mobile breakpoint (AUTHORITATIVE)
        TABLET: 1024,        // Tablet breakpoint  
        DESKTOP: 1200        // Desktop breakpoint
    },
    
    // Touch targets (Apple/Google guidelines)
    TOUCH_TARGETS: {
        MINIMUM: 44,         // Apple minimum
        RECOMMENDED: 48,     // Enterprise recommended
        COMFORTABLE: 56      // Premium experience
    },
    
    // Z-index layers (systematic hierarchy)
    Z_INDEX: {
        CANVAS: 1,
        GAME_CONTAINER: 10,
        UI_OVERLAYS: 1000,
        MOBILE_OVERLAYS: 10000,
        DEBUG_TOOLS: 50000,
        EMERGENCY_RECOVERY: 100000
    },
    
    // Performance thresholds
    PERFORMANCE: {
        MOBILE_FPS: 30,
        DESKTOP_FPS: 60,
        GESTURE_THRESHOLD: 30,     // Minimum swipe distance
        GESTURE_VELOCITY: 0.1,     // Minimum swipe velocity
        LONG_PRESS_DELAY: 500,     // Long press detection
        TAP_THRESHOLD: 10          // Maximum movement for tap
    },
    
    // Device detection scoring
    DETECTION: {
        USER_AGENT_SCORE: 4,
        SCREEN_SIZE_SCORE: 2,
        TOUCH_CAPABILITY_SCORE: 2,
        ORIENTATION_API_SCORE: 1,
        HIGH_DPI_SCORE: 1,
        MOBILE_THRESHOLD: 4
    },
    
    // Animation and timing
    TIMING: {
        TRANSITION_FAST: 150,
        TRANSITION_NORMAL: 300,
        TRANSITION_SLOW: 500,
        SCENE_TRANSITION: 350,
        PRELOADER_FADE: 800
    },
    
    // Colors and themes
    THEME: {
        BACKGROUND_PRIMARY: '#0f172a',
        BACKGROUND_SECONDARY: '#1e293b',
        ACCENT_PRIMARY: '#00d4ff',
        ACCENT_SECONDARY: '#0ea5e9',
        SUCCESS: '#10b981',
        WARNING: '#f59e0b',
        ERROR: '#ef4444'
    }
};

// Export individual constants for convenience
export const { BREAKPOINTS, TOUCH_TARGETS, Z_INDEX, PERFORMANCE, DETECTION, TIMING, THEME } = MOBILE_CONSTANTS;
